import React, { useEffect, useState } from 'react';
import { getMerchantBrandsList, unbindBrand } from '../services/brandService';
import { Table, Button, Form, Input, Select } from 'antd';
import BrandBind from '../components/Brand/BrandBind';
const { Option } = Select;
const PAGE_SIZE = 10;
const FIRST_PAGE = 1;

function MerchantBrandsList() {
    const [form] = Form.useForm()
    const [list, setList] = useState([]);
    const [totle, setTotal] = useState(0);
    const [tableLoading, setTableLoading] = useState(false);
    const [current, setCurrent] = useState(FIRST_PAGE);
    const [bindVisible, setBindVisible] = useState(false);
    const [currentBrand, setCurrentBrand] = useState();
    const [params, setParams] = useState({
        name: '',
        brandName: '',
        status: ''
    });
    const columns = [
        {
            title: '品牌',
            dataIndex: 'name',
            key: 'name'
        }, {
            title: '管理品牌ID',
            dataIndex: 'brandId',
            key: 'brandId'
        }, {
            title: '管理品牌',
            dataIndex: 'brandName',
            key: 'brandName'
        }, {
            title: '状态',
            key: 'status',
            render: (record) => (record && record.brandId ? '已绑定' : '未绑定')
        }, {
            title: '操作',
            key: 'action',
            render: (record) => (
                record && record.brandId ?
                    <Button onClick={() => handleBrandStatusChange(record, false)}>解绑</Button> :
                    <Button onClick={() => handleBrandStatusChange(record, true)} type="primary">挂靠</Button>
            )
        }
    ];

    useEffect(() => {
        getBrandList(FIRST_PAGE);
    }, []);

    function getBrandList(currentPage, data) {
        setTableLoading(true);
        const p = data || params;
        const c = currentPage || current || 1;
        getMerchantBrandsList({
            f: c * 10 - PAGE_SIZE,
            t: c * 10,
            ...p
        }).then((res) => {
            setList(res.data.data);
            setTotal(res.data.total);
            setTableLoading(false);
        }).catch(() => {
            setTableLoading(false);
        })
    }

    function handleSubmit() {
        setList([]);
        setCurrent(FIRST_PAGE);
        form.validateFields().then((values) => {
            setParams(values);
            getBrandList(FIRST_PAGE, values);
        })
    }

    function handleCurrentPageChange(page) {
        setList([]);
        getBrandList(page);
        setCurrent(page);
    }

    function handleBrandStatusChange(record, status) {
        if(status) {
            setBindVisible(true);
            setCurrentBrand(record);
            return;
        }
        unbindBrand(record.id).then(() => {
            getBrandList();
        })
    }

    function closeBindModal() {
        setBindVisible(false);
    }

    function bindSuccess() {
        getBrandList();
        closeBindModal();
    }

    return (
        <div className='p-merchant-brands-list'>
            <Form layout='inline' name='merchant_brands_list' form={form}>
                <Form.Item label="管理品牌" name="brandName">
                    <Input allowClear />
                </Form.Item>
                <Form.Item label="商家品牌" name="name">
                    <Input allowClear />
                </Form.Item>
                <Form.Item label="状态" name="status">
                    <Select style={{ width: 120 }}>
                        <Option value="">全部</Option>
                        <Option value="true">已绑定</Option>
                        <Option value="false">未绑定</Option>
                    </Select>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" onClick={handleSubmit}>
                        查询
                    </Button>
                </Form.Item>
            </Form>
            <br />
            <Table
                style={{backgroundColor: '#ffffff'}}
                tableLayout='fixed'
                columns={columns}
                dataSource={list}
                loading={tableLoading}
                rowKey={record => record.id}
                pagination={{
                    pageSize: PAGE_SIZE,
                    total: totle,
                    showQuickJumper: true,
                    current: current,
                    onChange: handleCurrentPageChange,
                    style: {
                        paddingRight: '20px'
                    }
                }}
            />
            <BrandBind
                visible={bindVisible}
                onCancel={closeBindModal}
                brandInfo={currentBrand}
                bindSuccess={bindSuccess}
            />
        </div>
    )
}

export default MerchantBrandsList;